var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCaledonia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M0 23.99h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed4135",
    d: "M0 16h30V0H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0035ad",
    d: "M0 8h30V0H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae600",
    d: "M11 5.42a6.58 6.58 0 1 1 0 13.16 6.58 6.58 0 0 1 0-13.16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4 12a7 7 0 1 0 14 0 7 7 0 0 0-14 0m4.67 5.7a6.16 6.16 0 0 1 1.91-11.85V7.1c-.26.14-.45.3-.5.56l-.02.3-.01.36s.07 0 .23-.13l.15-.07.15-.06v.7a.9.9 0 0 0 0 1.57v.24c-.22-.07-.43-.23-.6-.6-.15-.3-.52-.74-.52-.74s.18.5.2 1q.05.53.4.68h-.18v.84h.5q-.26.16-.27.4 0 .26.27.41h-.5v.84h.29a.7.7 0 0 0-.47.62c-.09.95-.26 1.68-.26 1.68s.28-.34.6-1.16q.2-.4.54-.57v.18c-.2.2-.32.52-.32.88 0 .37.13.7.32.89v.5a2 2 0 0 0-.81.26c-.25.19-.76.69-1.1 1.03m2.75-10.25q.27-.3.57-.8c.16-.3.08-.43.08-.43s0 .02-.11.12q-.26.22-.54.37v-.86a6.16 6.16 0 0 1 1.8 11.9c-.32-.33-.8-.82-1.1-1.07q-.25-.2-.7-.25v-.51q.31-.32.32-.89-.02-.56-.32-.88v-.18q.35.17.53.57c.33.82.61 1.16.61 1.16s-.17-.73-.26-1.68a.7.7 0 0 0-.46-.62h.28v-.84h-.5q.26-.15.27-.4 0-.24-.27-.41h.5v-.84h-.18q.35-.15.4-.67c.02-.5.2-1 .2-1s-.37.44-.51.73c-.18.37-.39.53-.61.6v-.24a.9.9 0 0 0 0-1.57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCaledonia);
export default __webpack_public_path__ + "static/media/new-caledonia.8cd02085953589c4b90aa70ae2574841.svg";
export { ForwardRef as ReactComponent };